// ** Custom Components
import Block from "components/layout/Block";
import { LISTING_TYPE } from "helpers/constants";
import { StyledDropdownButtonIcon } from "./DropdownButtonIcon.styled";
import { StyledDropdownContainer } from "./DropdownContainer.styled";

// #####################################################

const ListingTypeSelectorContent = ({
	close,
	selectedViewType,
	setViewType,
}) => {
	// #####################################################

	return (
		<Block flex column justifyBetween fullHeight>
			{/* Menu Główne */}
			<StyledDropdownContainer>
				{selectedViewType === LISTING_TYPE.GRID ? (
					<StyledDropdownButtonIcon
						name="list"
						onClick={() => {
							setViewType(LISTING_TYPE.LIST);
							close();
						}}
						isInsideDropdownMenu
					/>
				) : (
					<StyledDropdownButtonIcon
						name="th"
						onClick={() => {
							setViewType(LISTING_TYPE.GRID);
							close();
						}}
						isInsideDropdownMenu
					/>
				)}
			</StyledDropdownContainer>
		</Block>
	);
};

// #####################################################

export default ListingTypeSelectorContent;

// #####################################################
